/** Private uploads always enter the catalogue through Lissen's internal sender. */
export const PRIVATE_SONG_SENDER = "LissenMockDistro";
export const PRIVATE_SONG_DEFAULT_LABEL = "LissenMockLabel";
